export const PPT_MAKER_DESCRIPTION =
  'Quickly create simple powerpoint presentations with Powerpoint Maker!';

export const PPT_MAKER_MAX_SECTIONS = 10;

export const PPT_INPUT_METHOD = {
  TEXT: 'text',
  FILE: 'file',
} as const;

export const PPT_MAKER_INVALID_CONFIG_MESSAGE =
  'Oops! It looks like you are trying to generate a power point presentation with only one slide! Review and adjust your inputs accordingly.';
